<template>
  <section :class="$options.name">
    <Loader v-if="loading" />
    <Mapbox
      v-else
      access-token="pk.eyJ1IjoicmlkZW5pY2ViaWtlIiwiYSI6ImNqd3V6bGdwcTA0Zjk0YWxmYTNwb2IxeTgifQ.EM4THHDMhVkW0CsUW8zeog"
      :map-options="{
      style: 'mapbox://styles/ridenicebike/cjwv0nfqmh9mh1cp9wlp25131',
      center: [this.longitude, this.latitude],
      zoom: 12
    }"
      :geolocate-control="{
      show: true,
      position: 'top-right'
    }"
      :fullscreen-control="{
      show: true,
      position: 'top-right'
    }"
      @map-load="mapLoaded"
    />
  </section>
</template>
<script>
import Loader from "@/components/Loader";
import Mapbox from "mapbox-gl-vue";
export default {
  name: "Map",
  components: { Loader, Mapbox },
  data() {
    return {
      apiSpace: this.$store.state.apiSpace,
      apiToken: this.$store.state.apiToken,
      latitude: null,
      longitude: null,
      loading: true
    };
  },
  methods: {
    getMapCoordinates() {
      const contentful = require("contentful");
      const client = contentful.createClient({
        space: this.apiSpace,
        accessToken: this.apiToken
      });
      client
        .getEntry("68wFgErJVzPyBRZ5mBV2qU")
        .then(entry => {
          this.latitude = entry.fields.latitude;
          this.longitude = entry.fields.longitude;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    mapLoaded(map) {
      map.addLayer({
        id: "points",
        type: "symbol",
        source: {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: [this.longitude, this.latitude]
                },
                properties: {
                  title: "Nice Bike",
                  icon: "bicycle"
                }
              }
            ]
          }
        },
        layout: {
          "icon-image": "{icon}-15",
          "text-field": "{title}",
          "text-offset": [0, 0.6],
          "text-anchor": "top"
        },
        paint: {
          "text-color": "white"
        }
      });
    }
  },
  mounted() {
    this.getMapCoordinates();
  }
};
</script>
<style lang="scss">
#map {
  height: 50vh;
  @include breakpoint(xsl) {
    height: 100vh;
  }
  @include breakpoint(s) {
    height: 50vh;
  }
  .mapboxgl-ctrl-bottom-left,
  .mapboxgl-ctrl-bottom-right {
    display: none;
  }
}
</style>